// extracted by mini-css-extract-plugin
export default {"ConfirmMergeContainer":"ConfirmMerge-module__ConfirmMergeContainer--svghz","ConfirmMergeText":"ConfirmMerge-module__ConfirmMergeText--Lq1XQ"};